import { apiConstants } from './shared/config';

const routes = [
    {
        path: `/${apiConstants.code}/home`,
        name: `${apiConstants.code}.home`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "toponymygestao-home" */ `./views/Home.vue`),
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: 'Home',
        }
    },
    {
        path: `/${apiConstants.code}/settings`,
        name: `${apiConstants.code}.settings`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "toponymygestao-settings" */ './views/settings/DefinitionsDetails.vue'),
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: 'Configurações',
        }
    },
    {
        path: `/${apiConstants.code}/print`,
        name: `${apiConstants.code}.print_visible_emissions`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "toponymygestao-print_visible_emissions" */ './views/print/PrintVisibleBase.vue'),
        children: [
            {
                path: 'config',
                name: `${apiConstants.code}.print_visible_emissions.config`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "toponymygestao-print_visible_emissions" */ './views/print/PrintVisibleConfig.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'print_visible_emissions.title',
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: 'print_visible_emissions.title',
        }
    },
    {
        path: `/${apiConstants.code}/layers`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "toponymygestao-layers" */ './views/layer/LayerBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.layers`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "toponymygestao-layers" */ './views/layer/LayerList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Camadas',
                }
            },
            {
                path: ':type',
                name: `${apiConstants.code}.layers.create`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "toponymygestao-layers" */ './views/layer/LayerDetails.vue'),
                beforeEnter: (to, from, next) => {
                    let available = ['group', 'resource'];
                    if (available.indexOf(to.params.type) == -1){
                        next(false)
                    }else{
                        next();
                    }
                },
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Camada',
                }
            },
            {
                path: 'group/:id',
                name: `${apiConstants.code}.layers.show.group`,
                props: {isLayer: false},
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "toponymygestao-layers" */ './views/layer/LayerDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Camada',
                }
            },
            {
                path: 'resource/:id',
                name: `${apiConstants.code}.layers.show.item`,
                props: {isLayer: true},
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "toponymygestao-layers" */ './views/layer/LayerDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Camada',
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: 'Camadas',
        }
    },
    {
        path: `/${apiConstants.code}/regulations`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "toponymygestao-regulation" */ './views/regulation/RegulationBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.regulations`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "toponymygestao-regulation" */ './views/regulation/RegulationList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Regulamentos',
                }
            },
            {
                path: ':type',
                name: `${apiConstants.code}.regulations.create`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "toponymygestao-regulation" */ './views/regulation/RegulationDetails.vue'),
                beforeEnter: (to, from, next) => {
                    let available = ['group', 'item'];
                    if (available.indexOf(to.params.type) == -1){
                        next(false)
                    }else{
                        next();
                    }
                },
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Regulamento',
                }
            },
            {
                path: 'group/:id',
                name: `${apiConstants.code}.regulations.show.group`,
                // props: {isLayer: false},
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "toponymygestao-regulation" */ './views/regulation/RegulationDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Regulamento',
                }
            },
            {
                path: 'item/:id',
                name: `${apiConstants.code}.regulations.show.item`,
                // props: {isLayer: true},
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "toponymygestao-regulation" */ './views/regulation/RegulationDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Regulamento',
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: 'Regulamentos',
        }
    },
    {
        path: `/${apiConstants.code}/streetstatetype`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "toponymygestao-streetstatetype" */ './views/streetstatetype/StreetStateTypeBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.street_state_types`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "toponymygestao-streetstatetype" */ './views/streetstatetype/StreetStateTypeList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Estados Arruamento',
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.street_state_types.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "toponymygestao-streetstatetype" */ './views/streetstatetype/StreetStateTypeDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Estado Arruamento',
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.street_state_types.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "toponymygestao-streetstatetype" */ './views/streetstatetype/StreetStateTypeDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Estado Arruamento',
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: 'Estados Arruamento',
        }
    },
    {
        path: `/${apiConstants.code}/streetprepositiontype`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "toponymygestao-streetprepositiontype" */ './views/streetprepositiontype/StreetPrepositionTypeBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.street_preposition_types`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "toponymygestao-streetprepositiontype" */ './views/streetprepositiontype/StreetPrepositionTypeList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Preposições Arruamento',
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.street_preposition_types.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "toponymygestao-streetprepositiontype" */ './views/streetprepositiontype/StreetPrepositionTypeDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Preposição Arruamento',
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.street_preposition_types.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "toponymygestao-streetprepositiontype" */ './views/streetprepositiontype/StreetPrepositionTypeDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Preposição Arruamento',
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: 'Preposições Arruamento',
        }
    },
    {
        path: `/${apiConstants.code}/streettype`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "toponymygestao-streettype" */ './views/streettype/StreetTypeBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.street_types`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "toponymygestao-streettype" */ './views/streettype/StreetTypeList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Tipos Arruamento',
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.street_types.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "toponymygestao-streettype" */ './views/streettype/StreetTypeDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Tipo Arruamento',
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.street_types.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "toponymygestao-streettype" */ './views/streettype/StreetTypeDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Tipo Arruamento',
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: 'Tipos Arruamento',
        }
    },
    {
        path: `/${apiConstants.code}/housenumbertype`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "toponymygestao-housenumbertype" */ './views/housenumbertype/HouseNumberTypeBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.house_number_types`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "toponymygestao-housenumbertype" */ './views/housenumbertype/HouseNumberTypeList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Tipos Nº Polícia',
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.house_number_types.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "toponymygestao-housenumbertype" */ './views/housenumbertype/HouseNumberTypeDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Tipo Nº Polícia',
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.house_number_types.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "toponymygestao-housenumbertype" */ './views/housenumbertype/HouseNumberTypeDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Tipo Nº Polícia',
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: 'Tipos Nº Polícia',
        }
    },
    {
        path: `/${apiConstants.code}/housenumberclassificationtype`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "toponymygestao-housenumberclassificationtype" */ './views/housenumberclassificationtype/HouseNumberClassificationTypeBase.vue'),
        children: [
            {
                path: '/',
                name: `${apiConstants.code}.house_number_classification_types`,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "toponymygestao-housenumberclassificationtype" */ './views/housenumberclassificationtype/HouseNumberClassificationTypeList.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Classificações Nº Polícia',
                }
            },
            {
                path: 'add',
                name: `${apiConstants.code}.house_number_classification_types.create`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "toponymygestao-housenumberclassificationtype" */ './views/housenumberclassificationtype/HouseNumberClassificationTypeDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Classificação Nº Polícia',
                }
            },
            {
                path: ':id',
                name: `${apiConstants.code}.house_number_classification_types.show`,
                props: true,
                component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "toponymygestao-housenumberclassificationtype" */ './views/housenumberclassificationtype/HouseNumberClassificationTypeDetails.vue'),
                meta: {
                    auth: undefined,
                    hideHeaderName: true,
                    title: 'Classificação Nº Polícia',
                }
            },
        ],
        meta: {
            auth: undefined,
            hideHeaderName: true,
            title: 'Classificações Nº Polícia',
        }
    },
];

export default routes;
